import { render, staticRenderFns } from "./LearnMorePage.vue?vue&type=template&id=54a97299&scoped=true"
import script from "./LearnMorePage.vue?vue&type=script&lang=js"
export * from "./LearnMorePage.vue?vue&type=script&lang=js"
import style0 from "./LearnMorePage.vue?vue&type=style&index=0&id=54a97299&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a97299",
  null
  
)

export default component.exports